import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { CoreModule } from '../core.module';

@Injectable({
	providedIn: CoreModule,
})
export class ModalService {
	private _openedModal = new Subject<string>();

	private modals: any[] = [];

	// Ids requested via open() before their modal has registered (e.g. a parent
	// component's ngOnInit opens a modal synchronously, before Angular has
	// created/initialized the child app-modal that calls add()). Flushed by add(),
	// or dropped after the current macrotask so a late open() for a modal that no
	// longer exists can't pop up on some later page that reuses the same id.
	private pendingOpens = new Set<string>();

	get openedModal$() {
		return this._openedModal.asObservable();
	}

	add(modal: any) {
		this.modals.push(modal);

		if (this.pendingOpens.has(modal.id)) {
			this.pendingOpens.delete(modal.id);
			this.open(modal.id);
		}
	}

	remove(id: string) {
		const modalToRemove = _.find(this.modals, { id });
		this.modals = _.without(this.modals, modalToRemove);
	}

	open(id: string) {
		const modal = _.find(this.modals, { id });

		// Modal hasn't registered yet; queue it so add() opens it once it does.
		if (!modal) {
			this.pendingOpens.add(id);
			setTimeout(() => this.pendingOpens.delete(id));
			// eslint-disable-next-line no-console
			console.warn(`Modal with id ${id} not found yet; it will open automatically once registered.`);
			return;
		}

		modal.open();

		this._updateOpenedModal(id);
	}

	close(id: string) {
		this.pendingOpens.delete(id);

		const modal = _.find(this.modals, { id });

		if (!modal) return;

		modal.close();
	}

	modalCheck() {
		let hasOpen = false;
		this.modals.some(
			(modal) => {
				if (modal.isOpen) {
					hasOpen = true;
					return true;
				}

				return false;
			},
		);
		return hasOpen;
	}

	_updateOpenedModal(id: string) {
		this._openedModal.next(id);
	}
}
